<template>
  <!-- 商城审批流程 -->
  <div class="panel mt-20" v-if="order.flows.length > 0">
    <p>审批流程</p>
    <div class="mb-10">
      <el-steps :space="220" finish-status="success" :active="flowActiveIndex">
        <el-step
          :title="flow.categoryName"
          :key="flow.id"
          v-for="(flow, index) in approveflows"
          :status="flow.operate_type == 2 && flow.status == 1 ? 'error' : ''"
          class="order-step"
        >
          <div slot="description">
            <div
              v-if="index == flowActiveIndex && order.status == 2"
              class="text-primary"
            >
              审批中...
            </div>
            <div v-if="flow.status == 1">
              <p class="mb-0 mt-5">
                {{ flow.operator.name
                }}{{ flow.operate_type == 1 ? '审批通过' : '审批不通过' }}
              </p>
              <p class="mb-5">
                {{
                  $time(flow.operate_time).format(
                    flow.category == 50 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'
                  )
                }}
              </p>
              <p class="mb-5">{{ flow.operate_remark }}</p>
            </div>
          </div>
        </el-step>
      </el-steps>
    </div>

    <div
      class="approve-container"
      v-if="canApproveFlow(approveflows[flowActiveIndex])"
    >
      <template>
        <div class="mb-5 text-warning">
          审批原因：{{ approveflows[flowActiveIndex].desc }}
        </div>
        <el-button
          type="primary"
          size="small"
          style="width: 80px"
          @click="handleApprove(approveflows[flowActiveIndex].category)"
          >审批</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import { approveCustomerOrderV2 } from '@/service/getDataV2'
import store from '@/store/store'

const flowCategoryMap = {
  10: '下单商品审批',
  15: '底价商品审批',
  20: 'EC审批',
  30: '总价审批',
  40: '折扣审批',
}
export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      flowActiveIndex: -1,
      userInfo: store.getters.userInfo,
    }
  },
  computed: {
    approveflows() {
      this.flowActiveIndex = -1
      let flows = this.order.flows
        .sort(function (x, y) {
          return x.category - y.category
        })
        .map((item, index) => {
          item.categoryName = flowCategoryMap[item.category]
          if (item.role_name) {
            item.categoryName += `（${item.role_name}）`
          }
          if (item.status == 0 && this.flowActiveIndex == -1) {
            this.flowActiveIndex = index
          }
          return item
        })

      if (this.flowActiveIndex == -1) {
        this.flowActiveIndex = flows.length
      }
      return flows
    },
  },

  methods: {
    canApproveFlow(f) {
      if (this.order.status != 2) {
        return false
      }
      let flow = this.order.flows.filter((item) => item.id == f.id)[0]
      let approver = flow.approver.filter((item) => item.id == this.userInfo.id)
      return approver.length > 0
    },

    handleApprove() {
      let data = { id: this.order.id, result: true }
      let _this = this
      let cancelButtonText = '不通过'
      this.$prompt('备注', '报价单审批', {
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: cancelButtonText,
        inputPlaceholder: '选填',
        callback: async function (action, instance) {
          data.result = action == 'confirm'
          data.remark = instance.inputValue

          if (action == 'confirm' || action == 'cancel') {
            let res = await approveCustomerOrderV2(data)
            if (res.code == 0) {
              _this.$emit('approved', res.data)
            }
          }
        },
      })
    },
  },
}
</script>